<script lang="ts">
  import type { SerializedSeparatorBlock } from '../../types'

  let { block: _ }: { block: SerializedSeparatorBlock } = $props()
</script>

<hr class="separator-block" />

<style>
  /* Blocks are grid items, so margins don't collapse: after a text block's --space-7 bottom margin this adds up to a --space-9 gap. */
  .separator-block {
    margin: var(--space-4) 0 var(--space-9);
  }
</style>
